module.exports = __webpack_public_path__ + "static/media/Jennie_McDonald.bb0a267b.webp";